/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindOneQueryResponse, ProjectsControllerFindOnePathParams, ProjectsControllerFindOneQueryParams, ProjectsControllerFindOne400, ProjectsControllerFindOne401, ProjectsControllerFindOne403, ProjectsControllerFindOne404 } from "../../models/projectsController/ProjectsControllerFindOne";

function getProjectsControllerFindOneUrl(id: ProjectsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/projects/${id}` as const }  
  return res
}

/**
 * @summary Get a project by id
 * {@link /api/v1/projects/:id}
 */
export async function projectsControllerFindOne(id: ProjectsControllerFindOnePathParams["id"], params?: ProjectsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectsControllerFindOne400 | ProjectsControllerFindOne401 | ProjectsControllerFindOne403 | ProjectsControllerFindOne404>, unknown>({ method : "GET", url : getProjectsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}